import { render, staticRenderFns } from "./review.vue?vue&type=template&id=11780de0&"
import script from "./review.vue?vue&type=script&lang=js&"
export * from "./review.vue?vue&type=script&lang=js&"
import style0 from "./review.vue?vue&type=style&index=0&id=11780de0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11780de0')) {
      api.createRecord('11780de0', component.options)
    } else {
      api.reload('11780de0', component.options)
    }
    module.hot.accept("./review.vue?vue&type=template&id=11780de0&", function () {
      api.rerender('11780de0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/user/components/review.vue"
export default component.exports